import { Injectable } from '@angular/core';
import { ApplicationInsights, IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightsService {
  constructor() {}
 
  logException(exception: Error): void {
    console.error('Error (App Insights disabled):', exception);
  }
 
  setUserId(userId: string): void {
    // No-op
  }
 
  clearUserId(): void {
    // No-op
  }
 
  trackPageView(name?: string): void {
    // No-op
  }
 
  trackEvent(name: string, properties?: any): void {
    // No-op
  }
}
